module.exports = __webpack_public_path__ + "img/white-logo.df4b2f2a.svg";